import { Body, Header, Icon, Item, Title } from "./MyDayList.styled";
import { GrandChartMyDayStore } from "../../../../stores/grand-charts/grand-charts-my-day/grand-chart-my-day.store";
import { observer } from "mobx-react";
import { getIconInstrument, ucFirst } from "../../../../helpers";
import { INSTRUMENT_NAME, ServiceName } from "../../../../constants";
import { Course } from "./Course/Course";
import { Percentage } from "./Percentage/Percentage";
import { Modules } from "./Modules/Modules";
import { GroupLesson } from "./GroupLesson/GroupLesson";
import { Lesson } from "./Lesson/Lesson";
import { ButtonAction } from "./ButtonAction/ButtonAction";
import { useTranslation } from "react-i18next";

interface MyDayItemProps {
	grandChartMyDayStore: GrandChartMyDayStore;
}

export const MyDayItem = observer(({ grandChartMyDayStore }: MyDayItemProps) => {
	const { t } = useTranslation();

	return (
		<Item theme={grandChartMyDayStore.service.slug} $isPreService={grandChartMyDayStore.service.isPreService}>
			<Header>
				<Icon>
					{getIconInstrument(
						grandChartMyDayStore.instrument.icon as INSTRUMENT_NAME,
						grandChartMyDayStore.service.isPreService,
					)}
				</Icon>

				<Title>
					{ucFirst(t(`instruments.${grandChartMyDayStore.instrument.slug}`))}{" "}
					<span>{t(`services.${grandChartMyDayStore.service.slug as ServiceName}`)}</span> {t(`common.for`)}{" "}
					{t(`common.today`)}
				</Title>
			</Header>

			<Body>
				<Course grandChartMyDayStore={grandChartMyDayStore} />
				<Percentage grandChartMyDayStore={grandChartMyDayStore} />
				<Modules
					grandChartMyDayStore={grandChartMyDayStore}
					grand_chart_modules={grandChartMyDayStore.grand_chart_modules}
				/>
				<GroupLesson grandChartMyDayStore={grandChartMyDayStore} />
				<Lesson grandChartMyDayStore={grandChartMyDayStore} />
				<ButtonAction grandChartMyDayStore={grandChartMyDayStore} />
			</Body>
		</Item>
	);
});
